import { Component, OnInit, Input } from '@angular/core';
import { SegurosWPService } from 'src/app/core/http/web/segurosWp.service';

@Component({
  selector: 'app-preguntas-frecuentes',
  templateUrl: './preguntas-frecuentes.component.html',
  styleUrls: ['./preguntas-frecuentes.component.scss']
})
export class PreguntasFrecuentesComponent implements OnInit {
  public loadings: any;
  public errors: any;
  public showData: boolean = false;
  public showResp: number;
  @Input('load_serv') public load_serv: boolean = true;
  @Input('data') public data: any = null;
  constructor(
    private segWpServ: SegurosWPService
  ) { }

  ngOnInit() {
    if (this.load_serv) {
      this.getDataServ();
    }
  }
  getDataServ() {
    this.segWpServ.getDataDestacado().subscribe(data => {
      this.data = data;
      this.loadings = false;
    }, err => {
      console.error('Error | getDataAllSeguros: ', err);
      this.errors = err;
    });
  }

  reload() {
    this.loadings = true;
    this.getDataServ();
  }

}
